import  React                      from 'react';
import { studentStateType }        from '../../types';

import FormControlLabel            from '@material-ui/core/FormControlLabel';
import Radio                       from '@material-ui/core/Radio';
import RadioGroup                  from '@material-ui/core/RadioGroup';

import heb                         from '../../utils/heb';
import { makeStyles }              from '@material-ui/core/styles';

const blue = '#66C';


const useStyles = makeStyles(() => ({
    root: {
        height:         100,
        width:          '100%',
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
    },
    text_field: {
        height:          50,
        paddingLeft:     10,
        paddingRight:    10,
        backgroundColor: '#FFF',
        borderTop:       `1px solid transparent`,
        borderLeft:      `1px solid transparent`,
        borderRight:     `1px solid transparent`,
        borderBottom:    `1px solid #999`,
        //borderRadius:    '0.5em',
        fontSize:        20,
        color:           '#334',
        marginTop:       10,
        marginBottom:    10,
        '&:focus': {
          outline:       'none',
          borderBottom:  `2px solid ${ blue }`,
          height:        48
         },
        '&::placeholder': {
          color: '#667',
         },
    },
    radio: {
        color: '#00F'
    },
    radioContainer: {
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
    },
    radioText: {
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
         color:         '#334'
    },
    radioGroup: {
       display:  'flex',
       flexFlow: 'row',
    }
}))


type UnitType = {
    size:            number[];
    val:             string;
    variant:         string;
    studentState:    studentStateType;
    setStudentState: (val: studentStateType) => void;
}

const Unit: React.FC<UnitType> = ({ 
    size,
    val, 
    variant,
    studentState,
    setStudentState
}) => {

    const classes = useStyles();

    const [focus, setFocus] = React.useState(false)

    const width = React.useMemo(() => {
        return Math.min(400, size[0] - 80)
    },[size])

    const checked: { [key: string]: string } = React.useMemo(() => {
        return{
            allowNotifications: studentState.allowNotifications,
            arabic:             studentState.arabic
        }
    },[studentState])

      
    const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStudentState({ ...studentState, [event.target.name]: event.target.value });
    };
    

    const changeInputValue = (e: React.FormEvent) => {

        e.preventDefault();
    
        const target = e.target as HTMLInputElement;
    
        if (target.id === 'userName')    { setStudentState({ ...studentState, userName:    target.value }) }
        if (target.id === 'userEmail')   { setStudentState({ ...studentState, userEmail:   target.value }) }
        if (target.id === 'schoolName')  { setStudentState({ ...studentState, schoolName:  target.value }) }
        if (target.id === 'city')        { setStudentState({ ...studentState, city:        target.value }) }
        if (target.id === 'teacherName') { setStudentState({ ...studentState, teacherName: target.value }) }
    
    }

    return (
      <div className = { classes.root }>
        {
            variant === 'text'
            &&
            <input 
               className   = { classes.text_field }
               dir         = { focus && val === 'userEmail' && studentState.userEmail.length ? 'ltr' : 'rtl' }
               placeholder = { heb[`${ val }`] } 
               id          = { val }
               onFocus     = { () => setFocus(true) }
               onChange    = { changeInputValue }
               style       = {{
                   width: width
               }}
            />
        }
        {
            variant === 'checkBox'
            &&
            <div 
               className = { classes.radioContainer }
               dir       = 'rtl'
               style     = {{
                  width: width
               }}
            >
               <div 
                  className = { classes.radioText }
                  style     = {{
                    width: width - 50
                  }}
               >
                  { heb[`${ val }`] } 
               </div>
               <RadioGroup
                  className  = { classes.radioGroup }
                  aria-label = { val }
                  name       = { val }
                  value      = { checked[`${ val }`] }
                  onChange   = { handleCheck }
               >
                   <FormControlLabel value = "yes" control = { <Radio color = "primary"/>  }  label = { `כן` } />
                   <FormControlLabel value = "no"  control = { <Radio color = "primary"/>  }  label = { `לא` } />
               </RadioGroup>
            </div>
        }
      </div>
    );
}

export default Unit;
